/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unarchivebtn1Inputs */



/**
* | output |
* | --- |
* | "Bring back to the main list" |
*
* @param {Unarchivebtn1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const unarchivebtn1 = /** @type {((inputs?: Unarchivebtn1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unarchivebtn1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Bring back to the main list")
	if (locale === "es") return /** @type {LocalizedString} */ ("Devolver a la lista principal")
	return /** @type {LocalizedString} */ ("Вернуть на главную")
});
export { unarchivebtn1 as "unarchiveBtn" }